import { CommonModule } from "@angular/common";
import { Component, Input, model } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FUNCTION_RESULT_STATUS } from "@nova/common-interfaces";
import { IServicePlan } from "@rfm/shared-interfaces";
import { ServicePlanService } from "../../../shared/services/products/service-plan.service.mjs";

@Component({
  selector: "app-order-internet-plan",
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: "./internet-plan.component.html",
  styleUrl: "./internet-plan.component.scss",
})
export class OrderInternetPlanComponent {
  residential_servicePlans: IServicePlan[] | undefined;
  commercial_servicePlans: IServicePlan[] | undefined;

  selectedPlan = model<IServicePlan | undefined>();
  
  constructor(private servicePlanService: ServicePlanService) {
    this.servicePlanService.getAll().then((result) => {
      if (result.status === FUNCTION_RESULT_STATUS.SUCCESS) {
        this.residential_servicePlans = result
          .data!.filter((x) => x.active && !x.is_commercial)
          .sort((a, b) => a.amount - b.amount);
        this.commercial_servicePlans = result
          .data!.filter((x) => x.active && x.is_commercial)
          .sort((a, b) => a.amount - b.amount);
      }
    });
  }
  @Input() activateCallback!: (step: number) => void;
  goToNextStep(data: number) {
    if (this.activateCallback) {
      this.activateCallback(data); // Example usage of the function
    }
  }

  planSelected(event: any) {
    console.log(event);
    this.selectedPlan.set(this.residential_servicePlans?.find(x => x.slug === event.target.id));
  }
}
